module.exports = __webpack_public_path__ + "static/img/highlights.647d4a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/exhibition/highlights.jpg
// module id = lfxF
// module chunks = 0